import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { AlertSingleLine } from '@sdir/sds';
import { SubmitItemResult } from '../../../types/submitSequence';

export const SubmitItemResultInfo: FC<{ itemResult: SubmitItemResult }> = ({ itemResult }) => {
  const intl = useIntl();
  let alertType: string;
  let alertText: string;
  if (!itemResult.status) {
    alertType = 'warn';
    alertText = intl.formatMessage({ id: 'submitsteps.skipped' });
  } else if (itemResult.status.success) {
    alertType = 'success';
    alertText = intl.formatMessage({ id: 'submitsteps.success' });
  } else {
    alertType = 'error';
    alertText = itemResult.status.errors?.join('\n') || '';
  }
  return (
    <AlertSingleLine
      title={intl.formatMessage({ id: itemResult.item.labelId }, itemResult.item.formatParams)}
      type={alertType}
      text={alertText}
    />
  );
};
